import React from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { Render } from '../../platformui';
import BlockTypeRenderer from '../../framework/base/blocktype-renderer';
import MatomoTrackMediaAnalytics from '../../platformui/Matomo/matomo-track-media-analytics';
import MatomoTrackDataAttribute from '../../platformui/Matomo/matomo-track-data-attribute';

const Entries = (props) => {
  const classes = classNames({
    'c-intro-content': true,
  });

  return <div className={classes}>{props.children}</div>;
};

const StartPage = (props) => (
  <main id="content" className="main--preload">
    <h1 className="show-for-sr">{props.Content.Heading}</h1>

    {props.Content && props.Content.SubjectIntroContent && (
      <Render.Block
        blocks={props.Content.SubjectIntroContent[0]}
        propertyName="SubjectIntroContent"
        currentPageProps={props}
      >
        <BlockTypeRenderer />
      </Render.Block>
    )}

    {props.Content?.IntroContent?.length > 0 && (
      <div className="c-section">
        <div className="row">
          <div className="columns">
            <div className="c-section__inner">
              <div className="row">
                {props.Content.IntroHeading && (
                  <h2 className="show-for-sr">{props.Content.IntroHeading}</h2>
                )}
                <Entries {...props}>
                  <Render.Block
                    blocks={props.Content.IntroContent}
                    propertyName="IntroContent"
                    currentPageProps={props}
                  >
                    <BlockTypeRenderer />
                  </Render.Block>
                </Entries>
              </div>

              <div className="main">
                <div className="row c-theme-push-list">
                  {props.Content.ThemeHeading && (
                    <h2 className="show-for-sr">
                      {props.Content.ThemeHeading}
                    </h2>
                  )}
                  <Render.Block
                    blocks={props.Content.ThemeContent}
                    numOfThemeBlocks={
                      props.Content.ThemeContent &&
                      props.Content.ThemeContent.length
                    }
                    propertyName="ThemeContent"
                    currentPageProps={props}
                  >
                    <BlockTypeRenderer />
                  </Render.Block>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}

    <div className="main">
      <Render.Block
        blocks={props.Content.SectionContent}
        propertyName="SectionContent"
        currentPageProps={props}
      >
        <BlockTypeRenderer />
      </Render.Block>
      <Render.Block
        blocks={props.Content.MainContent}
        propertyName="MainContent"
        currentPageProps={props}
        stylePropertyName="SectionContent"
      >
        <BlockTypeRenderer />
      </Render.Block>
    </div>
    <MatomoTrackMediaAnalytics />
    <MatomoTrackDataAttribute />
  </main>
);

export default withRouter(StartPage);
